<template>
  <div class="k-page padding-50">
    <Row :gutter="20" v-if="userAccountDetails">
      <i-col :sm="12" :md="16">
        <UserProfileForm :userDetails="userAccountDetails"/>
        <Spin size="large" fix v-if="isLoading"></Spin>
      </i-col>
      <i-col :sm="12" :md="8">
        <Card :bordered="false" class="no-head-border pos-relative text-center">
          <p slot="title" class="text-left"><b>Avatar</b></p>
          <UserAvatar :avatar="userAccountDetails.avatar"/>
        <Spin size="large" fix v-if="isLoading"></Spin>
        </Card>
        <Card :bordered="false" style="margin-top:20px" class="no-head-border pos-relative">
          <p slot="title" class="text-left"><b>Saved payment methods</b></p>
          <UserCards/>
        </Card>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { fetchAccount } from '@/services/account'
import { logout } from '@/services/auth'
import UserProfileForm from '@/components/account-settings/UserProfileForm'
import UserCards from '@/components/account-settings/UserCards'
import UserAvatar from '@/components/account-settings/UserAvatar'

export default {
  components: {
    UserProfileForm,
    UserCards,
    UserAvatar
  },

  data () {
    return {
      userAccountDetails: null,
      isLoading: false
    }
  },

  mounted () {
    this.getUserAccountDetails()
  },

  methods: {
    getUserAccountDetails () {
      this.isLoading = true
      fetchAccount(localStorage.getItem('_id')).then(res => {
        this.userAccountDetails = res.data
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch user account details: ', err)
        this.isLoading = false
        logout()
      })
    }
  }
}
</script>
